import { ResourceGroupAccess } from "@/components/share/ResourceGroupAccess";
import { ResourceType } from "gitpod-next-api/gitpod/v1/event_pb";
import { type FC } from "react";

type AutomationGroupAccessProps = {
    workflowId: string;
    maxVisible?: number;
    className?: string;
};

export const AutomationGroupAccess: FC<AutomationGroupAccessProps> = ({ workflowId, maxVisible, className }) => {
    return (
        <ResourceGroupAccess
            resourceType={ResourceType.WORKFLOW}
            resourceId={workflowId}
            maxVisible={maxVisible}
            className={className}
            trackingPrefix="automation"
        />
    );
};
